import { useStore } from '@nanostores/react';
import { MenuDropdownItem } from './BaseMenuDropdown';
import { projectStore } from '~/lib/stores/project';

interface RenameDropdownItemProps {
  isLoading?: boolean;
  onSelect: () => void;
}

export function RenameDropdownItem({ isLoading, onSelect }: RenameDropdownItemProps) {
  const permissions = useStore(projectStore.permissions);

  if (!permissions.canRename) {
    return null;
  }

  const handleSelect = (event: Event) => {
    event.preventDefault();
    onSelect();
  };

  return (
    <MenuDropdownItem disabled={isLoading} onSelect={handleSelect}>
      <span className="i-lucide:pencil-line size-4 mt-0.5 group-hover:text-bolt-elements-textPrimary" />
      Rename…
    </MenuDropdownItem>
  );
}
